import { useOthers, useSelf } from "@configs/liveblocks.config"
import { useMemo } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import UserAvatarStack from "@molecules/UserAvatarStack/UserAvatarStack"

import styles from "./NavTopBarPagePresence.module.scss"

const NavTopBarPagePresence = () => {
    const self = useSelf()
    const others = useOthers()

    const isDesktop = useIsDesktop()

    const users = useMemo<AvatarUser[]>(() => {
        // The Liveblocks userId is stable per real user, so a user with multiple open tabs
        // appears once per connection. List self first, then others in connection order, and
        // dedupe on the id so each real user shows a single time; entries without an id can't
        // be deduped and always pass through.
        const orderedUsers: AvatarUser[] = []
        if (self != null) {
            orderedUsers.push({ ...self.info, id: self.id })
        }
        if (others != null) {
            others.forEach((other) => {
                orderedUsers.push({ ...other.info, id: other.id })
            })
        }

        const seenUserIds = new Set<string>()
        return orderedUsers.filter((avatarUser) => {
            if (avatarUser.id == null) {
                return true
            }
            const userId = String(avatarUser.id)
            if (seenUserIds.has(userId)) {
                return false
            }
            seenUserIds.add(userId)
            return true
        })
    }, [self, others])

    return (
        isDesktop && (
            <div className={styles.pagePresence}>
                {users && <UserAvatarStack users={users} limit={3} avatarSize="md" isLive={true} />}
            </div>
        )
    )
}

export default NavTopBarPagePresence
